<template>
  <div>
    <queryFrame @handlePage='handlePage' @handlePageSize='handlePageSize'
      :count="count" :current="page">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>接口名称:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable
              v-model.trim='query.ruleName'></lk-input>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label >门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>上传时间段:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择"   class="item" v-model.trim='query.uploadTime' ></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>上传状态:</label>
            <lk-select class="item" clearable v-model.trim='query.status'>
                <lk-option v-for="(item,index) in statuslist" :key="index" :value='index'>{{ item }}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns='columns' :data='tableData' >
        </lk-table>
      </div>
    </queryFrame>
  </div>
</template>
<script>
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import dataDirect from '../../services/dataDirect';
import utils from '../../libs/utils';
import queryFrame from '../../components/frame/QueryFrame.vue';

export default {
  name: 'dataUploadList',
  components: { queryFrame },
  mixins: [mapState, queryMixins],
  data() {
    return {
      errModal: false,
      errContent: '',
      forceLoading: false,
      singleLoading: false,
      taskIds: [],
      statuslist: {
        8: '文件上传成功',
        9: '文件上传失败',
      }, // 2、5、8才显示下载按钮
      query: {},
      tableData: [],
      columns: [
        {
          title: '序号',
          width: 60,
          render: (h, params) => h('span', params.index + (this.page - 1) * this.size + 1),
        },
        {
          title: '文件名称',
          key: 'fileName',
          minWidth: 116,
        },
        {
          title: '接口名称',
          minWidth: 116,
          key: 'ruleName',
        },
        {
          title: '上传时间',
          minWidth: 116,
          key: 'modifiedTime',
        },
        {
          title: '上传状态',
          minWidth: 116,
          key: 'status',
          render: (h, params) => h('span', {
            class: {
              error: params.row.status === 9,
            },
          }, this.statuslist[params.row.status]),
        },
        {
          title: '操作',
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: !(/^[2|5|8]$/.test(params.row.status) && this.handlePermission('dataUploadDownload')),
              },
              on: {
                click: () => {
                  console.log(params.row);
                  dataDirect.downloadHistory({ taskDetailId: params.row.id }).then((res) => {
                    utils.downLoadExcel(res, params.row.fileName, true);
                  }).catch((err) => {
                    utils.handleError(err);
                  });
                },
              },
            }, '下载'),
          ]),
        },
      ],
    };
  },
  methods: {
    getData() {
      this.tableData = [];
      this.params.size = this.size;
      this.params.page = this.page;
      if (this.params.uploadTime && this.params.uploadTime.length === 2) {
        this.params.uploadStartTime = this.params.uploadTime[0];
        this.params.uploadEndTime = this.params.uploadTime[1] + 57599000;// 8点到23:59:59
      }
      console.log(this.params);
      dataDirect.getHistoryUploadedData(this.params).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.count = data.count;
          data.list.forEach((item) => {
            item.modifiedTime = utils.exchangeTime(item.modifiedTime);
            this.tableData.push(item);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        uploadTime: [],
      };
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 16px;
  >*{
    margin-right: 8px
  }
}
</style>
